import { ApiHandler } from '@eshop/api-client'

export const updateGuarantee = async (recordId: number) => {
    const api = new ApiHandler({
        path: '/cart/update-guarantee',
        method: 'PATCH',
        body: {
            recordId,
            withGuarantee: true,
        },
    })

    const result = await api.send()
        .then(() => true)
        .catch(() => false)

    return result
}
